import { render, staticRenderFns } from "./ChangeNameCard.vue?vue&type=template&id=7228e760&"
import script from "./ChangeNameCard.vue?vue&type=script&lang=js&"
export * from "./ChangeNameCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports